import Tab from '@components/tabs'
import { Fragment, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Title from '@components/title'
import Column from '@components/column'
import { Profile } from '@commons/cards/profile'

import UserActiveBookings from './active-bookings'
import UserCancelledBookings from './cancelled-bookings'
import UserCompletedBookings from './booking-history'
import { RootState } from '@store/index'
import { useSelector } from 'react-redux'
import { Dashboard, User } from '@apis/index'
import TravelInquiry from './travel-inquiry'

const IndividualUser = () => {
  const { data: dashboard, loading } = useSelector(
    (state: RootState) => state.dashboard,
  )
  const navigate = useNavigate()
  const { state: id } = useLocation()
  const { data: user } = useSelector(
    (state: RootState) => state.inidividualUser,
  )

  const fetchUser = async () => {
    try {
      await User.find({ id: id, state: 'inidividualUser' })
    } catch (error) {}
  }
  const fetchDashboard = async () => {
    try {
      await Dashboard.list({ state: 'dashboard' })
    } catch (error) {}
  }
  useEffect(() => {
    fetchUser()
  }, [])
  useEffect(() => {
    fetchDashboard().then(() => {})
  }, [])
  const items = [
    {
      label: 'Active Bookings',
      component: UserActiveBookings,
      props: { user },
    },
    {
      label: 'Cancelled Bookings',
      component: UserCancelledBookings,
      props: { user },
    },
    {
      label: 'Booking History',
      component: UserCompletedBookings,
      props: { user },
    },
    {
      label: 'Travel Inquiry',
      component: TravelInquiry,
      props: { user },
    },
  ]

  return (
    <Fragment>
      <Column>
        <Title
          textone="User List >"
          texttwo="Details"
          textOneClick={() => navigate(-1)}
        />
        <Profile user={user} isUser={true} userDash={dashboard} />
        <Tab items={items} />
      </Column>
    </Fragment>
  )
}

export default IndividualUser
